// Считает проценты для прогресса
export const calculatePercent = (delivered: number | null | undefined = 0, total: number | null | undefined = 0) => {
  if (delivered === 0 || total === 0) return 0;
  if (delivered === total) return 100;
  return Math.floor((delivered! * 100) / total!);
};
